/**
 * Chat State Slice
 * Manages chat messages and assistant state with localStorage persistence
 */

import create from 'zustand';
import { persist } from 'zustand/middleware';
import type { ChatMessage, ChatStore } from '../../types';

export const useChatStore = create<ChatStore>()(
  persist(
    (set) => ({
      threadId: null,
      assistantId: null,
      messages: [],

      setThreadId: (threadId) => set({ threadId }),
      setAssistantId: (assistantId) => set({ assistantId }),
      setMessages: (messages) => set({ messages }),
      addMessage: (message) =>
        set((state) => ({ messages: [...state.messages, message] })),
    }),
    {
      name: 'chat-storage', // localStorage key
      partialize: (state) => ({
        // Only persist messages, not threadId/assistantId
        messages: state.messages,
      }),
    }
  )
);

// Maintain backward compatibility
export default useChatStore;
